import type { SxProps, Theme } from '@mui/material/styles';

/** Uniform padding around the stage icon in the dropdown menu (icon-only rows). */
export const COMPACT_ICON_PADDING = 0.5;

export const iconSx: SxProps<Theme> = {
  fontSize: 18,
  flexShrink: 0,
  color: 'text.primary',
  display: 'flex',
};

/**
 * Compact Select trigger: same vertical metrics as other `size="small"` outlined inputs (no custom py/minHeight).
 * Icon stays centered; horizontal space is constrained by the parent `maxWidth`.
 */
export const compactIconPickerSelectSx: SxProps<Theme> = {
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export const compactIconPickerMenuItemSx: SxProps<Theme> = {
  justifyContent: 'center',
  alignItems: 'center',
  p: COMPACT_ICON_PADDING,
  minHeight: 'auto',
};

export const menuPaperSx: SxProps<Theme> = {
  maxHeight: 280,
};

export const numberingPreviewSx: SxProps<Theme> = {
  fontSize: 18,
  fontWeight: 600,
  lineHeight: 1,
  color: 'text.primary',
  minWidth: 18,
  textAlign: 'center',
};
